import * as React from 'react';

interface IProps {
    label: React.ReactNode;
    id: string;
    onChange: (event: any) => void;
    value?: boolean;
    disabled?: boolean;
    className?: string;
    infoSection?: React.ReactNode;
    inlineDisplay: boolean;
    trueAlternativeLabel?: string;
    falseAlternativeLabel?: string;
    showErrorMessage?: boolean;
    errorText?: string;
}

export class RadioInput extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render(): React.ReactNode {
        const wrapperCss: string = this.props.inlineDisplay ? "input-group" : "d-flex flex-column flex-md-row";
        const radioCss: string = this.props.inlineDisplay ? "custom-control custom-radio" : "custom-control custom-radio specific-custom-radio full-width-radio";
        const trueLabel: string = this.props.trueAlternativeLabel ? this.props.trueAlternativeLabel : "Yes";
        const falseLabel: string = this.props.falseAlternativeLabel ? this.props.falseAlternativeLabel : "No";

        return (
            <div className="col-12 p-0" id={this.props.id}>
                {this.props.label}
                {this.props.infoSection}
                <div className={`${wrapperCss} mt-4`}>
                    <div className={`${radioCss}`}>
                        <input
                            id={`${this.props.id}Yes`}
                            className={`custom-control-input form-control ${this.props.className}`}
                            type="radio"
                            name={`${this.props.id}Yes`}
                            value="true"
                            checked={this.props.value === true}
                            onChange={this.props.onChange}
                            disabled={this.props.disabled} />
                        <label id={`${this.props.id}Yes-button`} className="custom-control-label cursor-pointer" htmlFor={`${this.props.id}Yes`}>{trueLabel}</label>
                    </div>
                    <div className={`${radioCss}`}>
                        <input
                            id={`${this.props.id}No`}
                            className={`custom-control-input ${this.props.className}`}
                            type="radio"
                            name={`${this.props.id}No`}
                            value="false"
                            checked={this.props.value === false}
                            onChange={this.props.onChange}
                            disabled={this.props.disabled}/>
                        <label id={`${this.props.id}No-button`} className="custom-control-label cursor-pointer" htmlFor={`${this.props.id}No`}>{falseLabel}</label>
                    </div>
                </div>
                {this.props.showErrorMessage &&
                    <div className="mb-3 invalid-feedback d-block">{this.props.errorText}</div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/RadioInput.tsx